import _ from 'lodash'
import { safeAwait } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import appConf from '../../../conf/appConf'

const wssid = _.get(global.window, 'ISO_REDUX_DATA.page.wssid')
const defaultFetcher = _.get(global.window, 'fetch')
const origin = _.get(global.window, 'location.origin')

const useReservice = (fetcher = defaultFetcher) => {
  const reservice = async (action = {}) => {
    const url = `${origin}${appConf.reserviceUrlPath}`
    const actionWithWssid = _.flow(
      () => _.cloneDeep(action),
      (clonedAction) => {
        return _.set(clonedAction, 'payload.wssid', wssid)
      }
    )()
    const [fetchError, response] = await safeAwait(fetcher(url, {
      method: 'PUT',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(actionWithWssid)
    }))
    if (fetchError) {
      const cause = {
        code: 'FETCH_ERROR',
        error: fetchError
      }
      throw new Error('請求失敗', { cause })
    }

    const [jsonError, resultAction] = await safeAwait(response.json())
    if (jsonError) {
      const cause = {
        code: 'FETCH_JSON_ERROR',
        error: jsonError
      }
      throw new Error('請求分析失敗', { cause })
    }

    return resultAction
  }

  return { reservice }
}

export default useReservice
